<template>
  <div v-if="content" id="underline-wrapper" :style="getStyle()">
    <div class="underline" :style="getColor()"></div>
  </div>
</template>

<script>
export default {
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  created() {
    this.getColor();
    this.getStyle();
  },
  methods: {
    getColor() {
      return {
        backgroundColor: `${
          this.content.color ? this.content.color.color : "#000"
        }`,
        width: `${this.content.width}%`,
        height: `${this.content.height}px`,
      };
    },
    getStyle() {
      return {
        textAlign: this.content.align,
        width: "100%",
        height: "50px",
        padding: "0 1.5em",
      };
    },
  },
};
</script>

<style lang="scss">
#underline-wrapper {
  max-width: $max-width;
  padding: 0 15px;
  .underline {
    margin: 0 1.5em;
    min-width: 40px;
  }
}

@media screen and (min-width: $tablet) {
  #underline-wrapper {
    .underline {
      margin: 0 1.5em;
    }
  }
}
@media screen and (min-width: $desktop) {
  #underline-wrapper {
    .underline {
      margin: 0 2em;
    }
  }
}
</style>
